/*
 * GlobalUpgradeListener — listens for the `rgm:upgrade-required` custom
 * event dispatched by the axios 402 interceptor and shows the shared
 * UpgradeModal. Mounted once at the App root.
 */
import React, { useEffect, useState } from "react";
import UpgradeModal from "@/components/upgrade/UpgradeModal";
import { useTier } from "@/hooks/useTier";

const GlobalUpgradeListener = () => {
  const { gatesEnforced } = useTier();
  const [modal, setModal] = useState(null);

  useEffect(() => {
    const handler = (ev) => {
      const d = ev.detail || {};
      setModal({
        feature: d.feature,
        currentTier: d.currentTier,
        requiredTier: d.requiredTier,
      });
    };
    window.addEventListener("rgm:upgrade-required", handler);
    return () => window.removeEventListener("rgm:upgrade-required", handler);
  }, []);

  if (!modal) return null;
  return (
    <UpgradeModal
      open={!!modal}
      onClose={() => setModal(null)}
      feature={modal.feature}
      currentTier={modal.currentTier}
      requiredTier={modal.requiredTier}
      gatesEnforced={gatesEnforced}
    />
  );
};

export default GlobalUpgradeListener;
